import * as apiClient from '../api/apiClient';
import { buildPagedQuery } from '../api/pagedQuery';
import { readAlumnoCodigosSesion, unwrapResponseModel } from './inscripcionesDto';
import { unwrapPagedResponseModel } from '../api/responseModel';

async function requestAndUnwrap(requestPromise) {
  const { data } = await requestPromise;
  return unwrapResponseModel(data);
}

function createPagedList(indexPath, defaultPageSize = 10) {
  return (query = { page: 1, pageSize: defaultPageSize }) => {
    const qs = buildPagedQuery(query);
    return apiClient.get(`${indexPath}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));
  };
}

function createInscripcionCursadaResource() {
  const listPaged = createPagedList('/api/ic/Index');
  return {
    resetForTests() {
      // Sin caché deduplicada tras F4-011.
    },
    list(query) {
      return listPaged(query);
    },
    lookup(query) {
      return listPaged({ pageSize: 5, ...query });
    },
    listPorAlumno(alumnoCodigos, query = { page: 1, pageSize: 10 }) {
      const codigos = alumnoCodigos ?? readAlumnoCodigosSesion();
      const qs = buildPagedQuery(query);
      return apiClient.get(`/api/ic/Index/${codigos}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));
    },
    get(id) {
      return requestAndUnwrap(apiClient.get(`/api/ic/${id}`));
    },
    save(payload) {
      return requestAndUnwrap(apiClient.post('/api/ic', payload));
    },
    update(payload) {
      return requestAndUnwrap(apiClient.put('/api/ic', payload));
    },
    delete(id) {
      return requestAndUnwrap(apiClient.get(`/api/ic/delete/${id}`));
    },
    changeStatus(id) {
      return requestAndUnwrap(apiClient.get(`/api/ic/changeStatus/${id}`));
    },
    changeStatusAll(alumnoCodigo) {
      return requestAndUnwrap(apiClient.get(`/api/ic/changeStatusAll/${alumnoCodigo}`));
    },
    saveMultiple(payload) {
      return requestAndUnwrap(apiClient.post('/api/ic/multiple', payload));
    },
    listCarrerasInscripcion(alumnoCodigos) {
      return requestAndUnwrap(apiClient.get(`/api/axc/inscripcion/${alumnoCodigos ?? readAlumnoCodigosSesion()}`));
    }
  };
}

function createInscripcionExamenResource() {
  const listPaged = createPagedList('/api/ie/Index');
  return {
    resetForTests() {
      // Sin caché deduplicada tras F4-011.
    },
    list(query) {
      return listPaged(query);
    },
    lookup(query) {
      return listPaged({ pageSize: 5, ...query });
    },
    get(id) {
      return requestAndUnwrap(apiClient.get(`/api/ie/${id}`));
    },
    delete(id) {
      return requestAndUnwrap(apiClient.get(`/api/ie/delete/${id}`));
    },
    changeStatus(id) {
      return requestAndUnwrap(apiClient.get(`/api/ie/changeStatus/${id}`));
    },
    saveMultiple(payload) {
      return requestAndUnwrap(apiClient.post('/api/ie/multiple', payload));
    },
    update(payload) {
      return requestAndUnwrap(apiClient.post('/api/ie/update', payload));
    }
  };
}

const inscripcionCursada = createInscripcionCursadaResource();
const inscripcionExamen = createInscripcionExamenResource();

export function resetInscripcionesCursadaListCacheForTests() {
  inscripcionCursada.resetForTests();
}

export function resetInscripcionesExamenListCacheForTests() {
  inscripcionExamen.resetForTests();
}

export function listInscripcionesCursada(query) {
  return inscripcionCursada.list(query);
}

export function lookupInscripcionesCursada(query) {
  return inscripcionCursada.lookup(query);
}

export function listInscripcionesCursadaPorAlumno(alumnoCodigos, query) {
  return inscripcionCursada.listPorAlumno(alumnoCodigos, query);
}

export function getInscripcionCursada(id) {
  return inscripcionCursada.get(id);
}

export function saveInscripcionCursada(payload) {
  return inscripcionCursada.save(payload);
}

export function updateInscripcionCursada(payload) {
  return inscripcionCursada.update(payload);
}

export function deleteInscripcionCursada(id) {
  return inscripcionCursada.delete(id);
}

export function changeStatusInscripcionCursada(id) {
  return inscripcionCursada.changeStatus(id);
}

export function changeStatusAllInscripcionesCursada(alumnoCodigo) {
  return inscripcionCursada.changeStatusAll(alumnoCodigo);
}

export function saveInscripcionesCursadaMultiple(payload) {
  return inscripcionCursada.saveMultiple(payload);
}

export function listCarrerasInscripcionAlumno(alumnoCodigos) {
  return inscripcionCursada.listCarrerasInscripcion(alumnoCodigos);
}

export function listInscripcionesExamen(query) {
  return inscripcionExamen.list(query);
}

export function lookupInscripcionesExamen(query) {
  return inscripcionExamen.lookup(query);
}

export function getInscripcionExamen(id) {
  return inscripcionExamen.get(id);
}

export function deleteInscripcionExamen(id) {
  return inscripcionExamen.delete(id);
}

export function changeStatusInscripcionExamen(id) {
  return inscripcionExamen.changeStatus(id);
}

export function saveInscripcionesExamenMultiple(payload) {
  return inscripcionExamen.saveMultiple(payload);
}

export function updateInscripcionExamen(payload) {
  return inscripcionExamen.update(payload);
}
